<template>
  <BaseSerch/>
</template>
<script>
import BaseSerch from 'operations/knowledgeBase/baseSerch.vue'
export default {
    components:{
      BaseSerch
    }
}
</script>